<div class="text-gray-800 font-inter flex flex-col">
  <!-- Sidebar -->
  <app-sidebar [isHidden]="isSidebarHidden" (isHiddenChange)="onSidebarToggle($event)" *ngIf="isAuthenticated"></app-sidebar>

  <!-- Contenido principal -->
  <main class="transition-sidebar h-screen flex-1">
    <section class="content flex-1 overflow-auto">
      <div class="fixed top-0 left-0 right-0 z-30 h-[60px] bg-white" *ngIf="isAuthenticated">
        <app-notifications></app-notifications>
      </div>

      <!-- Contenedor principal de contenido -->
      <div id="main-section" class="overflow-y-auto transition-sidebar p-6"
        [ngClass]="{ 'ml-64': !isSidebarHidden && isAuthenticated, 'p-6': isAuthenticated}" style="padding-top: 80px;">
        <router-outlet></router-outlet>
      </div>
    </section>
  </main>
</div>